export default __webpack_public_path__ + "static/media/logo-finanzas.14d3dcc3.svg";